export class PropertySideNavigationTree {
    static propertyRootItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'PROPERTY_HOME',
            path: '/property/:communityId/:customerId/home',
            icon: '',
            text: 'Property Workspace',
            tooltip: 'Property Workspace',
            items: [],
            isWorkspace: true
        },

        {
            id: `${parentId}_2`,
            parentId,
            name: 'PROPERTY',
            path: null,
            icon: '',
            text: 'Account',
            tooltip: 'Account',
            items: PropertySideNavigationTree.propertyItems(`${parentId}_2`)
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'PROPERTY_MANAGEMENT',
            path: null,
            icon: ``,
            text: 'Administration',
            tooltip: 'Administration',
            items: PropertySideNavigationTree.propertyManagementItems(`${parentId}_3`)
        }
    ];

    static propertyManagementItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'PROPERTY_COLLECTION',
            path: '/property/:communityId/:customerId/owner-collection',
            icon: '',
            text: 'Owner Collection',
            tooltip: 'Owner Collection',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'PROPERTY_OWNER_INFO_NOTES',
            path: '/property/:communityId/:customerId/notes',
            icon: '',
            text: 'Property Notes',
            tooltip: 'Property Notes',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'PROPERTY_OWNER_COMMUNICATIONS',
            path: '/property/:communityId/:customerId/owner-communications',
            icon: '',
            text: 'Communications',
            tooltip: 'Communications',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'PROPERTY_AMENITIES',
            path: '/property/:communityId/:customerId/amenities',
            icon: '',
            text: 'Amenities',
            tooltip: 'Amenities',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'PROPERTY_DOCUMENTS',
            path: '/property/:communityId/:customerId/manage-documents',
            icon: '',
            text: 'Owner Documents',
            tooltip: 'Owner Documents',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'PROPERTY_INFO_ALL_VIOLATIONS',
            path: '/property/:communityId/:customerId/violations/detailed_violation_log',
            icon: '',
            text: 'Violations',
            tooltip: 'Violations',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'ARCHITECTURAL_APPLICATION',
            path: '/property/:communityId/:customerId/manage-acc',
            icon: '',
            text: 'Manage ACC',
            tooltip: 'Manage Architectural Application',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'PROPERTY_ASSESSMENT_RULES',
            path: '/property/:communityId/:customerId/assessmentrules',
            icon: '',
            text: 'Assessment Rules',
            tooltip: 'Assessment Rules',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'PROPERTY_BILLING_RULES',
            path: '/property/:communityId/:customerId/billingruleassignments',
            icon: '',
            text: 'Rule Assignments',
            tooltip: 'Rule Assignments',
            items: []
        }
    ];

    static propertyItems = (parentId: string) => [
        {
            id: `${parentId}_1`,
            parentId,
            name: 'PROPERTY_DASHBOARD',
            path: '/property/:communityId/:customerId/dashboard',
            icon: '',
            text: 'Portal Dashboard',
            tooltip: 'Portal Dashboard',
            items: []
        },
        {
            id: `${parentId}_2`,
            parentId,
            name: 'PROPERTY_INFO',
            path: '/property/:communityId/:customerId/information',
            icon: '',
            text: 'Property Information',
            tooltip: 'Property Information',
            items: []
        },
        {
            id: `${parentId}_3`,
            parentId,
            name: 'PROPERTY_OWNER_INFO',
            path: '/property/:communityId/:customerId/owner-information',
            icon: '',
            text: 'Owner Information',
            tooltip: 'Owner Information',
            items: []
        },
        {
            id: `${parentId}_4`,
            parentId,
            name: 'PROPERTY_CONTACTS',
            path: '/property/:communityId/:customerId/contact-information',
            icon: '',
            text: 'Contact Information',
            tooltip: 'Contact Information',
            items: []
        },
        {
            id: `${parentId}_5`,
            parentId,
            name: 'PROPERTY_DIRECTORY_SHARING',
            path: '/property/:communityId/:customerId/directory-sharing',
            icon: '',
            text: 'Directory Sharing',
            tooltip: 'Directory Sharing',
            items: []
        },
        {
            id: `${parentId}_6`,
            parentId,
            name: 'PROPERTY_OWNER_STATEMENTS',
            path: '/property/:communityId/:customerId/statement',
            icon: '',
            text: 'Statement',
            tooltip: 'Statement',
            items: []
        },
        {
            id: `${parentId}_7`,
            parentId,
            name: 'PROPERTY_ONE_TIME_PAYMENT',
            path: '/property/:communityId/:customerId/make-one-time-payment',
            icon: '',
            text: 'Make a Payment',
            tooltip: 'Make One-Time Payment',
            items: []
        },
        {
            id: `${parentId}_8`,
            parentId,
            name: 'PROPERTY_ARCHITECTURAL_APPLICATION',
            path: '/property/:communityId/:customerId/architectural-application',
            icon: '',
            text: 'Architectural Application',
            tooltip: 'Architectural Application',
            items: []
        },
        {
            id: `${parentId}_9`,
            parentId,
            name: 'PROPERTY_RESIDENT_DOCUMENTS',
            path: '/property/:communityId/:customerId/documents',
            icon: '',
            text: 'Resident Portal Documents',
            tooltip: 'Resident Portal Documents',
            items: []
        },
        {
            id: `${parentId}_10`,
            parentId,
            name: 'PROPERTY_ADDITIONAL_INFO',
            path: '/property/:communityId/:customerId/additional-info',
            icon: '',
            text: 'Additional Information',
            tooltip: 'Additional Information',
            items: []
        },
        {
            id: `${parentId}_11`,
            parentId,
            name: 'PROPERTY_COMPLIANCE',
            path: '/property/:communityId/:customerId/compliance',
            icon: '',
            text: 'Compliance',
            tooltip: 'Compliance',
            items: []
        },
        {
            id: `${parentId}_12`,
            parentId,
            name: 'PROPERTY_RESTRICTION_SUMMARY',
            path: '/property/:communityId/:customerId/restriction-summary',
            icon: '',
            text: 'Restrictions Summary',
            tooltip: 'Restrictions Summary',
            items: []
        },
        {
            id: `${parentId}_13`,
            parentId,
            name: 'PROPERTY_REPORT_VIOLATION',
            path: '/property/:communityId/:customerId/report-violation',
            icon: '',
            text: 'Report a Violation',
            tooltip: 'Report a Violation',
            items: []
        },
        {
            id: `${parentId}_14`,
            parentId,
            name: 'MAINTENANCE_WORK_ORDERS',
            path: '/property/:communityId/:customerId/work-orders',
            icon: '',
            text: 'Work Orders',
            tooltip: 'Work Orders',
            items: []
        }
    ];

    static hiddenPropertyItems = (parentId: string) => [
        {
            id: `${parentId}_8`,
            parentId,
            name: 'PROPERTY_RECURRING_PAYMENT',
            path: '/property/:communityId/:customerId/set-recurring-payment',
            icon: '',
            text: 'Setup Recurring Payments',
            tooltip: 'Setup Recurring Payments',
            items: []
        }
    ];
}
